import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

interface AttachmentNameModalProps {
    show: boolean;
    onHide: () => void;
    onConfirm: (displayName: string | undefined) => Promise<void>;
    files: File[];
    currentIndex: number;
    submitting?: boolean;
}

export const AttachmentNameModal: React.FC<AttachmentNameModalProps> = ({
    show,
    onHide,
    onConfirm,
    files,
    currentIndex,
    submitting = false,
}) => {
    const [displayName, setDisplayName] = useState('');

    const currentFile = files[currentIndex];
    const totalFiles = files.length;
    const isLastFile = currentIndex >= totalFiles - 1;

    // Reset display name when file changes
    useEffect(() => {
        if (show) {
            setDisplayName('');
        }
    }, [show, currentIndex]);

    const handleConfirm = async () => {
        try {
            await onConfirm(displayName.trim() || undefined);
        } catch (err) {
            console.error('Error uploading attachment:', err);
        }
    };

    const handleClose = () => {
        setDisplayName('');
        onHide();
    };

    if (!currentFile) return null;

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    {totalFiles > 1
                        ? `Namnge bilaga (${currentIndex + 1} av ${totalFiles})`
                        : 'Namnge bilaga'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group className="mb-3">
                    <Form.Label>Filnamn</Form.Label>
                    <Form.Control
                        type="text"
                        value={currentFile.name}
                        disabled
                        readOnly
                    />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Visningsnamn (valfritt)</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder={currentFile.name}
                        value={displayName}
                        onChange={(e) => setDisplayName(e.target.value)}
                        disabled={submitting}
                        autoFocus
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                handleConfirm();
                            }
                        }}
                    />
                    <Form.Text className="text-muted">
                        Lämna tomt för att använda filnamnet
                    </Form.Text>
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose} disabled={submitting}>
                    Avbryt
                </Button>
                <Button variant="primary" onClick={handleConfirm} disabled={submitting}>
                    {isLastFile ? 'Ladda upp' : 'Nästa'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
